import { LogLevel, Modal, ModalType, showBanner } from '@sprint/sprint-react-components';
import React, { FunctionComponent, useContext } from 'react';
import { FormsRequest } from '../../Api/FormsRequest';
import { RepositoryFactoryContext } from '../../index';

interface Props {
    selectedRowsForDeletion: number[];
    dataGridEntitySingular: string;
    dataGridEntityPlural: string;
    modalShown: boolean;
    reloadDataGrid: () => void;
    closeModal: () => void;
}

const FormsDeleteModal: FunctionComponent<Props> = (props: Props) => {
    const formsRepository = useContext(RepositoryFactoryContext).getApiRepository(new FormsRequest());

    const deleteRows = (): Promise<boolean> => {
        return formsRepository
            .delete(props.selectedRowsForDeletion)
            .then((success: any) => {
                showBanner({
                    message: success.data.message,
                    level: LogLevel.SUCCESS,
                });
                props.reloadDataGrid();
                return true;
            })
            .catch((err: any) => {
                showBanner({
                    message: err?.message ?? err,
                    level: LogLevel.ERROR,
                });
                return false;
            });
    };

    return (
        <Modal
            isOpen={props.modalShown}
            type={ModalType.DELETE}
            title={
                props.selectedRowsForDeletion.length > 1
                    ? `Delete These ${props.dataGridEntityPlural ?? 'Rows'}`
                    : `Delete This ${props.dataGridEntitySingular ?? 'Row'}`
            }
            close={props.closeModal}
            onSubmit={deleteRows}
        >
            <>
                Are you sure you want to delete
                {props.selectedRowsForDeletion.length > 1
                    ? ` these ${props.selectedRowsForDeletion.length} ${(
                          props.dataGridEntityPlural ?? 'rows'
                      ).toLowerCase()}?`
                    : ` this ${(props.dataGridEntitySingular ?? 'row').toLowerCase()}?`}
                <>
                    <br />
                    <br />
                    Remember, if a form is hosted on your website, it will no longer show.
                </>
            </>
        </Modal>
    );
};

export default FormsDeleteModal;
